import { render, staticRenderFns } from "./McpEn.vue?vue&type=template&id=77b7128c&scoped=true"
import script from "./McpEn.vue?vue&type=script&lang=js"
export * from "./McpEn.vue?vue&type=script&lang=js"
import style0 from "./McpEn.vue?vue&type=style&index=0&id=77b7128c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b7128c",
  null
  
)

export default component.exports